import React from "react";
import _ from "lodash";
import { List, Image } from "semantic-ui-react";
import allStores from "../data/all-stores";

export const RangeIds = ({ stores }) => {
  const ids = _.map(stores, (store) => {
    return store.store;
  });
  const list = ids.sort().join(", ");
  return <p>{list}</p>;
};

export const RangeUuids = ({ stores }) => {
  const uuids = _.map(stores, (store) => {
    return store.uuid;
  });
  const list = uuids.join(", ");
  return <p>{list}</p>;
};

export const RangeIdsByLocation = ({ stores, region }) => {
  const country = _.filter(stores, (store) => {
    return store.region === region;
  });
  const ids = _.map(country, (c) => {
    return c.id;
  });
  const list = ids.sort().join(", ");
  return (
    <p>
      <strong>{region}:</strong> {list}
    </p>
  );
};

export const StockIds = ({ availabilities }) => {
  const uuids = _.map(availabilities, (store) => {
    return store.locationId;
  });
  //convert location uuid to store id
  const ids = _.map(uuids, (uuid) => {
    const store = allStores.find((item) => {
      return item.uuid === uuid;
    });
    return store.id;
  });
  const list = ids.sort().join(", ");
  return <p>{list}</p>;
};

export const ShowDate = ({ date }) => {
  let d = new Date(date);
  return d.toDateString();
};

export const ImageList = ({ images }) => {
  return (
    <List horizontal>
      {images.map((image) => (
        <List.Item key={image.imageId}>
          <Image src={`${image.url}?w=100`} />
        </List.Item>
      ))}
    </List>
  );
};
